import { ApprovalState, ApprovalUserRole, ReportType } from '@fdm/api-client';
import { AREA_LEAD_INSP_ENGINEER_POLICY } from './creator-area-lead-insp-engineer_Version4';
import { AREA_OPS_SUPERINTENDANT_POLICY } from './creator-area-ops-superintendant_Version4';
import { ASSET_TYPE_HCEPO_POLICY } from './creator-asset-type-hcepo_Version4';
import { GENERAL_DIRECTOR_POLICY } from './creator-general-director_Version4';
import { GENERAL_MANAGER_OPERATIONS_POLICY } from './creator-general-manager-operations_Version4';
import { INSP_ENG_SUPERVISOR_POLICY } from './creator-insp-eng-supervisor_Version4';
import { LTA_POLICY } from './creator-lta';
import { PRODUCTION_OPERATIONS_MANAGER_POLICY } from './creator-production-operations-manager_Version4';
import { ReportFormPage } from '../../report-form-control.service';
import { INITIATOR_POLICY } from './creator-initiator';
import { ACTION_ITEM_OWNER_POLICY } from './creator-action-item-owner';
import { OWNER_OPERATOR_ADVISOR } from './creator-owner-operator-advisor';


// Type structure: Role -> ReportType -> ReportFormPage -> ApprovalState[]
type PageStates = Partial<Record<ReportFormPage, ApprovalState[]>>;
type ReportNode = Partial<Record<ReportType, PageStates>>;
// type CreatorPolicy = Partial<Record<CreatorRole, ReportNode>>;
type CreatorPolicy = Partial<Record<ApprovalUserRole, ReportNode>>;

export const CREATOR_POLICY: CreatorPolicy = {
  [ApprovalUserRole.AreaLeadInspEng]: AREA_LEAD_INSP_ENGINEER_POLICY, // +
  [ApprovalUserRole.ActionItemOwner]: ACTION_ITEM_OWNER_POLICY, // +
  [ApprovalUserRole.AssetTypeHCEPO]: ASSET_TYPE_HCEPO_POLICY, // +
  [ApprovalUserRole.AreaOpsSuperintendent]: AREA_OPS_SUPERINTENDANT_POLICY, // +
  [ApprovalUserRole.InspEngSupervisor]: INSP_ENG_SUPERVISOR_POLICY, // +
  [ApprovalUserRole.OpsAdvisor]: OWNER_OPERATOR_ADVISOR, // +
  [ApprovalUserRole.GeneralDirector]: GENERAL_DIRECTOR_POLICY, // +
  [ApprovalUserRole.GeneralManagerOperation]: GENERAL_MANAGER_OPERATIONS_POLICY, // +
  [ApprovalUserRole.Owner]: OWNER_OPERATOR_ADVISOR, // +
  [ApprovalUserRole.LocalTechnicalAuthority]: LTA_POLICY, // +
  [ApprovalUserRole.ProductionOperationManager]: PRODUCTION_OPERATIONS_MANAGER_POLICY, // +
  [ApprovalUserRole.Initiator]: INITIATOR_POLICY, // +
};